import { createStore } from 'redux'

const initialState = {
  options: []
}


const productOptionsReducer = (state = initialState, action) => {
  switch(action.type){
    case "LOAD_PRODUCT_OPTIONS":
      return set(state, action.initialState);
    default:
      return state;
  }
}


const set = (state,new_props) => {
  return Object.assign({}, state, new_props);
}

const store = createStore(productOptionsReducer);

const ReduxStore = () => { return store; }

export default ReduxStore;




// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/app/reducers/product_option_store.js